import script from "./menus.vue?vue&type=script&lang=ts&setup=true"
export * from "./menus.vue?vue&type=script&lang=ts&setup=true"

import "./menus.vue?vue&type=style&index=0&id=513d40d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-513d40d9"]])

export default __exports__